import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import { getLotSerialInputPlaceHolder } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import Select from 'src/common/refactoredComponents/select/Select';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { StyledDiv } from 'src/pages/consignmentBilling/components/billing/BillingContainer.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const LotSerialRPQtyInput = forwardRef((props, ref) => {
    const {
        item,
        index,
        lotItem,
        lotItemIdx = 0,
        addSerialNumber,
        lotSerialValueEntered,
        showTopLabel,
        showBundlefromTableList,
        isFromReportScreen,
        checkNewAddedProduct,
        lotTextAlign,
        vendorCaseErrorRedirection,
        onIsSerialUnknown = () => { },
        showAddSerialButton = true,
    } = props;
    const bottomLabelClickHandler = () => {
        if (item.isBundleItem) {
            showBundlefromTableList(true, index, item.productCFN,item?.unqId);
        } else {
            addSerialNumber(item, index);
        }
    };

    const isLanguageChanged = useSelector(state => state.loginReducer.isLanguageChanged);
 
    useImperativeHandle(ref, () => ({
            bottomLabelClickHandler,
        }));
    const { t } = useTranslation();
    const [showClear, setShowClear] = useState(false);
    const [lot, setLot] = useState('');

    useEffectWithErrorLogging(() => {
        const serialValue = lotItem?.lotSerialNumber || '';
        setLot(serialValue);
        setShowClear(serialValue ? true : false);
    }, [lotItem, lotItem?.lotSerialNumber]);

    return (
        <>
            <SerialRPQtyInputContainer
                height={
                    checkNewAddedProduct &&
                    !item.isSplitLotSerialItem &&
                    '100%'
                }
                justifyContent={
                    checkNewAddedProduct &&
                    !item.isSplitLotSerialItem &&
                    'flex-start'
                }
                alignItems={'center'}
            >
                {!checkNewAddedProduct  ? (
                    isFromReportScreen ? (
                    <Box
                        title={
                            item.isBundleItem
                                ? undefined
                                : lotItem?.lotSerialNumber ||
                                  lotItem?.Serial ||
                                  item.lotSerialNumber
                        }
                        style={{
                            width: '100%',
                            maxWidth: '100%',
                            fontSize: '13px',
                            fontFamily: 'AvenirNextWorld Regular',
                            textAlign: lotTextAlign,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            marginTop: isLanguageChanged ? '-10px' : '-17px',
                        }}
                    >
                        {item.isBundleItem
                            ? t(
                                  'reportUsage.common.textWithInputs.notApplicable'
                              )
                            : (lotItem?.lotSerialNumber ||
                                  lotItem?.Serial ||
                                  item.lotSerialNumber)}
                    </Box>
                    ) : null
                ) : (
                    <>
                        {isFromReportScreen && checkNewAddedProduct && (
                            <>
                                {item.batches?.length > 0 ? (
                                    <SelectContainer
                                        display={'flex'}
                                        height={'100%'}
                                        justifyContent={'center'}
                                        alignItems={
                                            checkNewAddedProduct && 'flex-end'
                                        }
                                        maxHeight={
                                            checkNewAddedProduct && '62px'
                                        }
                                    >
                                        <Select
                                            id="reportUsage-lotSerialRPQtyInput-reportPayment-batches"
                                            value={
                                                item?.lotSerialUnknown
                                                    ? ''
                                                    : lot
                                            }
                                            options={item.batches}
                                            name={'batches'}
                                            onChange={(e) => {
                                                lotSerialValueEntered(
                                                    e,
                                                    item,
                                                    index,
                                                    lotItem,
                                                    lotItemIdx,
                                                    null,
                                                    null,
                                                    lotItem
                                                );
                                                setLot(e.batches);
                                                setShowClear(
                                                    e.batches?.length > 0
                                                );
                                            }}
                                            placeholder={getLotSerialInputPlaceHolder(
                                                item,
                                                t('reportUsage.unknown')
                                            )}
                                            borderRadius={'6px'}
                                            border={'1.5px solid #EBEDED'}
                                            width={'70%'}
                                            editable={true}
                                            showClear={showClear}
                                            crossIconMargin={'-5px'}
                                            showOnFocus={true}
                                        />
                                    </SelectContainer>
                                ) : (
                                    <TextWithInputs
                                        id={`reportUsage-lot-serial-input-${item.productCFN}-${index}`}
                                        styleObj={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: isLanguageChanged
                                                ? checkNewAddedProduct && 'center'
                                                : checkNewAddedProduct &&'flex-end',
                                            maxHeight: item.noItemInBundleErr
                                                ? '87px'
                                                : isLanguageChanged
                                                    ? checkNewAddedProduct && '85px'
                                                    : checkNewAddedProduct && '70px',
                                        }}
                                        width={
                                            item.isBundleItem
                                                ? item.noItemInBundleErr
                                                    ? '75%'
                                                    : '100%'
                                                : isLanguageChanged
                                                    ? '78%'
                                                    : '70%'
                                        }
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        xl={12}
                                        name={'lotSerialNumber'}
                                        bottomLabel={
                                                showAddSerialButton && !item.isInvalidItemMsg &&
                                                (item.isBundleItem
                                                    ? t('reportUsage.record.reportPayment.LotSerialRPQtyInput.addItems')
                                                    : item.isSplitLotSerialItem ? ''
                                                    : '+' + t('reportUsage.itemList.lotorserial'))
                                            }
                                        topLabel={
                                            showTopLabel
                                                ? item?.cfn?.startsWith('S33')
                                                    ? t(
                                                          'reportUsage.record.itemsList.LotSerialQtyInput.addItems'
                                                      )
                                                    : t(
                                                          'reportUsage.record.itemsList.LotSerialQtyInput.lotSerial'
                                                      )
                                                : ''
                                        }
                                        placeholder={getLotSerialInputPlaceHolder(
                                            item,
                                            t('reportUsage.unknown')
                                        )}
                                        inputDisabled={
                                            item.isBundleItem ||
                                            item?.cfn?.startsWith('S33')
                                        }
                                        onLabelClick={bottomLabelClickHandler}
                                        onkeyUp={(e) =>
                                            lotSerialValueEntered(
                                                e,
                                                item,
                                                index,
                                                lotItem,
                                                lotItemIdx,
                                                null,
                                                null,
                                                lotItem
                                            )
                                        }
                                        isBundleItem={item.isBundleItem}
                                        cursor={'pointer'}
                                        inputBorder={
                                            lotItem?.isInvalidLotSerialMsg?.length >
                                                0 && '2px solid #FACFD6'
                                        }
                                        lotSerial={true}
                                        defaultValue={
                                            item?.lotSerialUnknown
                                                ? ''
                                                : (lotItem?.lotSerialNumber || '')
                                        }
                                        value={
                                            item?.lotSerialUnknown
                                                ? ''
                                                : (lotItem?.lotSerialNumber || '')
                                        }
                                        vendorCaseErrorRedirection={
                                            vendorCaseErrorRedirection
                                        }
                                        noItemInBundleErr={
                                            item.noItemInBundleErr
                                        }
                                    />
                                )}
                            </>
                        )}
                    </>
                )}
            </SerialRPQtyInputContainer>
        </>
    );
});

export default LotSerialRPQtyInput;

export const SerialRPQtyInputContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 8px;
    justify-content: ${({ justifyContent }) => justifyContent};
    height: ${({ height }) => height};
    align-items: ${({ alignItems }) => alignItems};
    min-width: 0;
    max-width: 100%;
    width: 100%;
`;

export const ErrorContainer = styled.div`
    width: 70%;
`;
export const SelectContainer = styled.div`
    display: ${({ display }) => display};
    align-items: ${({ alignItems }) => alignItems};
    max-height: ${({ maxHeight }) => maxHeight};
    justify-content: ${({ justifyContent }) => justifyContent};
    height: ${({ height }) => height};
`;
